/**
 * Checkout Utility Functions
 * Pure functions for checkout data manipulation
 */

import type {
    CheckoutData,
    CheckoutInitParams,
    CheckoutLineItem,
    CheckoutSession,
    Promotion,
} from '../resources/checkout';

// Re-export types from resources for convenience
export type {
    CheckoutData, CheckoutInitParams, CheckoutLineItem, CheckoutSession, Promotion
};

export class CheckoutUtils {
    /**
     * Get checkout session ID
     */
    static getCheckoutSessionId(checkoutData: CheckoutData): string {
        return checkoutData.checkoutSession?.id || '';
    }

    /**
     * Get checkout line items  
     */
    static getLineItems(checkoutData: CheckoutData): CheckoutLineItem[] {
        const lineItems = checkoutData.checkoutSession?.lineItems;
        if (!Array.isArray(lineItems)) {
            return [];
        }
        return lineItems;
    }

    /**
     * Get checkout total
     */
    static getTotal(checkoutData: CheckoutData): number {
        const totalPrice = checkoutData.checkoutSession?.totalPrice;
        return typeof totalPrice === 'number' ? totalPrice : 0;
    }

    /**
     * Check if customer is club member
     */
    static isClubMember(checkoutData: CheckoutData): boolean {
        return checkoutData.customerIsClubMember || false;
    }
}
